import {getFormJsonData} from '../utils/form';
import {AppContext} from '../utils/app-init';
import {gtag, postConversion} from "../utils/conversion";

export class IadLeadForm {
	constructor(protected formEl: HTMLFormElement, protected formParentEl: HTMLElement, protected context: AppContext, protected checkboxButtons: string[], protected gtagUniqId: string) {
	}

	get submitEl(): HTMLInputElement|null {
		return this.formEl.querySelector('button[type=submit]');
	}

	get inputEls(): NodeListOf<HTMLInputElement> {
		return this.formEl.querySelectorAll('input[required]');
	}

	public async submit() {
		if(this.submitEl) this.submitEl.classList.add('disabled');
		const formData = getFormJsonData(this.formEl);
		try {
			const response = await fetch(`/api/express/${this.context.NetworkSlug}/${this.context.OperationId}/${this.context.FranchiseSlug}/register-lead`, {
				credentials: 'same-origin',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				method: 'POST',
				body: JSON.stringify({campaignId: this.context.CampaignId, ...formData})
			});

			if(response.ok) {
				if(this.gtagUniqId !== '') {
					gtag('event', 'conversion', {
						'send_to': 'AW-312389111/' + this.gtagUniqId,
						'form-data': JSON.stringify({campaignId: this.context.CampaignId, ...formData})
					});
					postConversion('Lead');
				}

				const formValidate = document.querySelector('.form-validate img');
				if(formValidate instanceof HTMLImageElement) formValidate.classList.add('confirmation');
				this.formParentEl.classList.add('completed');
			}
			const data = await response.json();
			console.log(response.ok, data);
		} catch(e) {
			console.log(e);
		}
		if(this.submitEl) this.submitEl.classList.remove('disabled');
	}

	public initFormInputBehavior() {

		this.checkboxButtons.forEach(name => {
			const checkboxEl: HTMLInputElement|null = document.querySelector(`input[name="${name}"]`);
			const btnYesEl = document.querySelector(`.${name}.btn-yes`);
			const btnNoEl = document.querySelector(`.${name}.btn-no`);
			if(!checkboxEl) throw new Error(`undefined checkbox input named ${name}`);
			if(!btnYesEl) throw new Error(`undefined btn-yes with class ${name}`);
			if(!btnNoEl) throw new Error(`undefined btn-no with class ${name}`);

			btnYesEl.addEventListener('click', () => {
				if(!btnYesEl.classList.contains('selected')) btnYesEl.classList.add('selected');
				if(btnNoEl.classList.contains('selected')) btnNoEl.classList.remove('selected');
				checkboxEl.checked = true;
			})

			btnNoEl.addEventListener('click', () => {
				if(!btnNoEl.classList.contains('selected')) btnNoEl.classList.add('selected');
				if(btnYesEl.classList.contains('selected')) btnYesEl.classList.remove('selected');
				checkboxEl.checked = false;
			})
		})

		if(this.submitEl)
			this.submitEl.onclick = async (e) => {
				this.inputEls.forEach((input) => {
					if(!input.classList.contains('dirty')) {
						input.classList.add('dirty');
					}
				});
			};

		this.inputEls.forEach((input) => {
			input.addEventListener('click', toggleDirtyClass);
		});

		function toggleDirtyClass(e: FocusEvent) {
			const input = e.target as Element;
			if(!input.classList.contains('dirty')) {
				input.classList.add('dirty');
				input.removeEventListener('click', toggleDirtyClass);
			}
		}

		this.formEl.addEventListener('submit', async (event) => {
			event.preventDefault();
			if(this.formEl.checkValidity()) {
				await this.submit();
			}
		});

		return this;
	}
}
